module.exports = __webpack_public_path__ + "img/9674f1e4469044868cb19de410b8f300.e0be6c38.jpg";